export class GetLocationsByNameClassic {
    constructor() {
        this.getLocationsByName = async (name) => {
            var _a;
            (_a = GetLocationsByNameClassic.abortController) === null || _a === void 0 ? void 0 : _a.abort();
            GetLocationsByNameClassic.abortController = new AbortController();
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/locations-search/${encodeURIComponent(name)}`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'get',
                    signal: GetLocationsByNameClassic.abortController.signal,
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                if (error instanceof DOMException && error.name === 'AbortError') {
                    return [];
                }
                console.warn('[locations-search] request failed:', error);
                return [];
            }
        };
    }
}
GetLocationsByNameClassic.abortController = null;
export default GetLocationsByNameClassic;
